<template>
  <div class="max-w-2xl mx-auto px-4 py-6 text-gray-200">
    <div v-if="isAuthenticated" />
    <div>
      <h2 class="text-xl font-bold text-gray-100 mb-4">
        {{ handleUser && handleUser.my_set ? handleUser.my_set.name : '' }} Drops
      </h2>
      <div v-if="dropsLoaded">
        <div v-if="userDrops[0]" class="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 gap-3">
          <div
            v-for="userDrop in userDrops"
            :key="userDrop._id"
            class="tw-card flex flex-col"
          >
            <!-- Thumbnail -->
            <a :href="`d/${userDrop._id}`" class="block aspect-square overflow-hidden rounded-t-lg">
              <img
                :src="
                  userDrop.thumbnail && userDrop.thumbnail.file !== ''
                    ? userDrop.thumbnail.file
                    : userDrop.polygon && userDrop.polygon.thumbnail
                      ? userDrop.polygon.thumbnail.url
                      : dropsLogo
                "
                :alt="userDrop.title"
                class="w-full h-full object-cover transition-transform duration-200 hover:scale-105"
              >
            </a>
            <!-- Info -->
            <div class="p-2 flex flex-col flex-1">
              <p class="text-sm font-medium text-gray-100 truncate">
                {{ userDrop.title }}
              </p>
              <p class="text-xs text-gray-500 mt-0.5 mb-2">
                {{ formatDate(userDrop.date) }}
              </p>
              <div class="flex items-center gap-1 mt-auto">
                <a
                  :href="`d/${userDrop._id}`"
                  class="tw-btn-nav px-1.5 py-1 text-xs"
                  title="Open in AR"
                >
                  <font-awesome-icon :icon="['fas', 'play']" />
                </a>
                <a
                  :href="`/d/${userDrop._id}/share`"
                  class="tw-btn-nav px-1.5 py-1 text-xs ml-auto"
                  title="Share"
                >
                  <font-awesome-icon :icon="['fas', 'share']" />
                </a>
              </div>
            </div>
          </div>
        </div>
        <p v-else class="text-gray-400 mt-4">
          {{ handleUser ? handleUser.name : '' }} doesn't have any published drops yet.
        </p>
      </div>
      <div v-else class="flex justify-center mt-8">
        <div class="w-10 h-10 border-4 border-gray-600 border-t-blue-400 rounded-full animate-spin" />
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
export default {
  data () {
    return {
      userHandle: this.$route.params.handle,
      userDrops: [],
      userSet: '',
      dropsLoaded: false
    }
  },
  asyncData ({ req, res }) {
    return {
      baseUrl:
        'https://' +
        (process.server ? req.headers.host : window.location.hostname)
    }
  },
  // test - if works, move to a loginComplete route
  created () {},
  computed: {
    ...mapState(['session', 'user', 'authToken', 'handleUser', 'dropsLogo']),
    ...mapGetters(['isAuthenticated'])
  },
  async mounted () {
    if (this.$cookies.get('authToken')) {
      try {
        const response = await this.$axios.get(
          '/updatedUser',
          {
            headers: {
              Authorization: 'Bearer ' + this.$cookies.get('authToken')
            }
          }
        )
        await this.$store.commit('user', response.data)
        await this.$store.commit('authToken', response.data.token)
        this.$cookies.set('authToken', response.data.token)
      } catch (err) {
        // non-fatal — user data stays as-is from the Vuex store
      }
    }

    try {
      const response = await this.$axios.get(
        `/getmyset/${this.userHandle}`
      )
      const handleUser = response.data
      this.$store.commit('handleUser', handleUser)
      // resetting here as a ductape fix. in /blank it's happening too late and can cause an error
      this.$store.commit('resetDropState')

      if (handleUser && handleUser.my_set) {
        // set userdrops equal to the reverse order of my_set.drops array
        this.userDrops = handleUser.my_set.drops.reverse()
        this.userSet = handleUser.my_set._id
      }

      this.dropsLoaded = true
    } catch (err) {
      console.error('[handle] failed to load drops for', this.userHandle, err)
      this.dropsLoaded = true
    }
  },

  methods: {
    formatDate (d) {
      const date = new Date(d)
      return (
        date.getMonth() + 1 + '/' + date.getDate() + '/' + date.getFullYear()
      )
    },
    loadGLBs () {
      try {
        this.$axios
          .post('/getSignedURL', {
            bucketName: 'glb',
            filename: 'cartoon_lowpoly_eart_planet_4a_reduced.glb'
          })
          .then((res) => {
            this.earth = res.data.url
          })
      } catch (error) {
        // console.log('axios getsignedurl error ' + error)
      }
    }
  }
}
</script>
